export const TableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: 'Nombre',
                    type: 'text',
                    key: 'name',
                },
                {
                    title: 'Código',
                    type: 'text',
                    key: 'code',
                },
                {
                    title: 'Área',
                    type: 'custom-html',
                    key: 'area',
                    modifier: (value) => {
                        if (value) {
                            return value.name;
                        } else {
                            return value;
                        }
                    }
                },
                {
                    title: 'Nombre formulario',
                    type: 'text',
                    key: 'form_name',
                },
                // {
                //     title: 'Norma',
                //     type: 'text',
                //     key: 'rule_name',
                // },
                {
                    title: 'Normas',
                    type: 'custom-html',
                    key: 'rules',
                    isVisible: true,
                    modifier: (item) => {
                        let tmp = ''
                        item.forEach((element, index) => {
                            tmp += `<p>${element.rule}</p>`
                        });
                        return tmp;
                    }
                },
                {
                    title: 'Estado',
                    type: 'custom-html',
                    key: 'is_active',
                    isVisible: true,
                    modifier: (item) => {
                        let className = 'success';
                        let status = 'Activo';
                        if (item == 0) {
                            className = 'danger';
                            status = 'Inactivo';
                        }
                        return `<span class="badge badge-sm badge-pill badge-${className}">${status}</span>`;
                    }
                },
            ],
            actionObj: {
                title: 'Acciones',
                type: 'action',
            }
        }
    },
}